import React, { useState } from 'react';
import { ArrowUpRight, ArrowDownRight, Clock } from 'lucide-react';
import { TransactionModal } from './TransactionModal';
const tradeActivities = [{
  type: 'buy' as const,
  asset: 'BTC',
  amount: '0.00082670',
  price: '95,790.0',
  time: '11:35 PM',
  date: 'Today'
}, {
  type: 'sell' as const,
  asset: 'BTC',
  amount: '0.00115416',
  price: '91,172.5',
  time: '4:18 PM',
  date: 'Today'
}, {
  type: 'buy' as const,
  asset: 'ETH',
  amount: '1.50000000',
  price: '3,240.5',
  time: '10:31 PM',
  date: 'Yesterday'
}, {
  type: 'sell' as const,
  asset: 'ETH',
  amount: '0.75000000',
  price: '3,285.0',
  time: '2:45 PM',
  date: 'Yesterday'
}, {
  type: 'buy' as const,
  asset: 'SOL',
  amount: '25.00000000',
  price: '142.8',
  time: '9:20 AM',
  date: 'Yesterday'
}, {
  type: 'buy' as const,
  asset: 'BTC',
  amount: '0.00095000',
  price: '89,450.0',
  time: '6:15 PM',
  date: '2 days ago'
}, {
  type: 'sell' as const,
  asset: 'SOL',
  amount: '10.00000000',
  price: '138.5',
  time: '11:30 AM',
  date: '2 days ago'
}, {
  type: 'buy' as const,
  asset: 'ETH',
  amount: '2.00000000',
  price: '3,180.0',
  time: '3:45 PM',
  date: '3 days ago'
}, {
  type: 'sell' as const,
  asset: 'BTC',
  amount: '0.00125000',
  price: '88,920.0',
  time: '8:30 AM',
  date: '3 days ago'
}, {
  type: 'buy' as const,
  asset: 'SOL',
  amount: '15.00000000',
  price: '135.2',
  time: '5:15 PM',
  date: '4 days ago'
}, {
  type: 'sell' as const,
  asset: 'ETH',
  amount: '1.20000000',
  price: '3,150.0',
  time: '12:45 PM',
  date: '4 days ago'
}, {
  type: 'buy' as const,
  asset: 'BTC',
  amount: '0.00180000',
  price: '87,650.0',
  time: '9:00 AM',
  date: '5 days ago'
}];
const depositWithdrawActivities = [{
  type: 'deposit' as const,
  asset: 'USDT',
  amount: '5,000.00',
  status: 'Completed',
  time: '09:15 AM',
  date: 'Today'
}, {
  type: 'withdraw' as const,
  asset: 'BTC',
  amount: '0.50000000',
  status: 'Completed',
  time: '03:22 PM',
  date: 'Yesterday'
}, {
  type: 'deposit' as const,
  asset: 'USD',
  amount: '10,000.00',
  status: 'Completed',
  time: '11:45 AM',
  date: 'Yesterday'
}, {
  type: 'withdraw' as const,
  asset: 'ETH',
  amount: '1.25000000',
  status: 'Completed',
  time: '5:30 PM',
  date: '2 days ago'
}, {
  type: 'deposit' as const,
  asset: 'USDT',
  amount: '2,500.00',
  status: 'Completed',
  time: '10:15 AM',
  date: '2 days ago'
}, {
  type: 'deposit' as const,
  asset: 'BTC',
  amount: '0.10000000',
  status: 'Completed',
  time: '2:45 PM',
  date: '3 days ago'
}, {
  type: 'withdraw' as const,
  asset: 'USD',
  amount: '5,000.00',
  status: 'Completed',
  time: '8:20 AM',
  date: '3 days ago'
}, {
  type: 'deposit' as const,
  asset: 'SOL',
  amount: '50.00000000',
  status: 'Completed',
  time: '4:10 PM',
  date: '4 days ago'
}, {
  type: 'withdraw' as const,
  asset: 'USDT',
  amount: '3,000.00',
  status: 'Completed',
  time: '1:30 PM',
  date: '4 days ago'
}, {
  type: 'deposit' as const,
  asset: 'ETH',
  amount: '2.50000000',
  status: 'Completed',
  time: '7:45 AM',
  date: '5 days ago'
}];
export function ActivityFeed() {
  const [activeTab, setActiveTab] = useState<'trades' | 'deposits'>('trades');
  const [selectedTransaction, setSelectedTransaction] = useState<any>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const activities = activeTab === 'trades' ? tradeActivities : depositWithdrawActivities;
  const handleActivityClick = (activity: any) => {
    // Only open modal for trades
    if (activeTab === 'trades') {
      setSelectedTransaction(activity);
      setIsModalOpen(true);
    }
  };
  return <>
      <div className="bg-background-secondary border border-border-subtle rounded-[20px] flex flex-col overflow-hidden" data-id="element-281">
        <div className="flex items-center justify-between px-4 md:px-6 pt-4 md:pt-6 pb-3 md:pb-4" data-id="element-282">
          <h3 className="text-base md:text-lg font-semibold text-text-primary" data-id="element-283">
            Recent Activity
          </h3>
          <button className="text-xs text-brand-purple-lighter hover:text-brand-purple-light transition-colors font-ui" data-id="element-284">
            View All
          </button>
        </div>

        {/* Tabs */}
        <div className="flex items-center gap-1 px-4 md:px-6 pb-3 md:pb-4 border-b border-border-subtle overflow-x-auto" data-id="element-285">
          <button onClick={() => setActiveTab('trades')} className={`
            px-3 py-1.5 rounded-lg text-sm font-medium transition-all whitespace-nowrap
            ${activeTab === 'trades' ? 'bg-background-elevated text-white' : 'text-text-secondary hover:text-white hover:bg-background-elevated/50'}
          `} data-id="element-286">
            Trades
          </button>
          <button onClick={() => setActiveTab('deposits')} className={`
            px-3 py-1.5 rounded-lg text-sm font-medium transition-all whitespace-nowrap
            ${activeTab === 'deposits' ? 'bg-background-elevated text-white' : 'text-text-secondary hover:text-white hover:bg-background-elevated/50'}
          `} data-id="element-287">
            <span className="hidden sm:inline" data-id="element-288">Deposits & Withdrawals</span>
            <span className="sm:hidden" data-id="element-289">Deposits</span>
          </button>
        </div>

        {/* Activity List - Scrollable with max height */}
        <div className="overflow-y-auto px-4 md:px-6 py-3 md:py-4" style={{
        maxHeight: '600px'
      }} data-id="element-290">
          <div className="space-y-3 md:space-y-4" data-id="element-291">
            {activities.map((activity, idx) => <button key={idx} onClick={() => handleActivityClick(activity)} className={`w-full flex items-start gap-2 md:gap-3 pb-3 md:pb-4 border-b border-border-subtle last:border-0 last:pb-0 text-left ${activeTab === 'trades' ? 'hover:bg-background-elevated/50 -mx-2 md:-mx-3 px-2 md:px-3 py-2 rounded-lg transition-colors cursor-pointer' : ''}`} data-id="element-292">
                <div className={`
                  w-7 h-7 md:w-8 md:h-8 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5
                  ${activity.type === 'buy' || activity.type === 'deposit' ? 'bg-success/10 text-success' : 'bg-danger/10 text-danger'}
                `} data-id="element-293">
                  {activity.type === 'buy' || activity.type === 'deposit' ? <ArrowDownRight size={14} className="md:w-4 md:h-4" data-id="element-294" /> : <ArrowUpRight size={14} className="md:w-4 md:h-4" data-id="element-295" />}
                </div>

                <div className="flex-1 min-w-0" data-id="element-296">
                  <div className="flex items-center justify-between mb-1 gap-2" data-id="element-297">
                    <span className="text-sm font-medium text-text-primary capitalize truncate" data-id="element-298">
                      {activity.type} {activity.asset}
                    </span>
                    <span className="text-xs text-text-secondary flex items-center gap-1 flex-shrink-0" data-id="element-299">
                      <Clock size={10} data-id="element-300" />
                      {activity.time}
                    </span>
                  </div>

                  <div className="flex items-center justify-between text-xs gap-2" data-id="element-301">
                    <span className="text-text-secondary truncate" data-id="element-302">
                      {activity.amount} {activity.asset} @{' '}
                      {activity.price ? `$${activity.price}` : (activity as any).status}
                    </span>
                    <span className="text-text-tertiary flex-shrink-0" data-id="element-303">
                      {activity.date}
                    </span>
                  </div>
                </div>
              </button>)}
          </div>
        </div>
      </div>

      <TransactionModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} transaction={selectedTransaction} data-id="element-304" />
    </>;
}